import { EventIds } from 'constants/index';
import { useCallback } from 'react';
import { useMutation, ApolloError } from '@apollo/client';
import { ContentSuggestionPayload } from 'components/Filters/context/SearchBarContext/types';
import { ModifiersPayload } from 'controllers/SearchController/types';
import { log } from 'utils/log';
import getFilterParamsToType from './helpers/getFilterParamsToType';
import {
    CreateUserRecentSearch,
    GetUserRecentSearch,
} from './userRecentSearch.gql';

export const useCreateUserRecentSearch = ({
    isAuthenticated,
}: {
    isAuthenticated: boolean;
}) => {
    const [createUserRecentSearch] = useMutation(CreateUserRecentSearch, {
        refetchQueries: [
            {
                query: GetUserRecentSearch,
            },
        ],
        onError: (error: ApolloError) => {
            log.error(
                'Failed to create a user recent search',
                EventIds.FailedToCreateUserRecentSearch,
                error,
            );
        },
    });

    const handleCreateUserRecentSearch = useCallback(
        (modifiers: (ModifiersPayload | ContentSuggestionPayload)[]) => {
            if (!isAuthenticated) {
                return;
            }

            modifiers.forEach(([params, filterSlug]) => {
                const filterType = getFilterParamsToType(params);

                if (filterType && filterSlug) {
                    createUserRecentSearch({
                        variables: {
                            filterType,
                            filterSlug,
                        },
                    });
                }
            });
        },
        [createUserRecentSearch, isAuthenticated],
    );

    return handleCreateUserRecentSearch;
};
